import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./ExpertSubscriptions.css";

import Modal from "react-bootstrap/Modal";
import { realtorSubscriptionApi } from "../../../Services/Realtor/RealtorApi/RealtorApi";
import { fetchProductList } from "../../../Services/Subscription/subscriptionApi";
import { toast } from "react-toastify";


const PurchaseSubscriptionModal = (props) => {
    const dispatch = useDispatch();
    const userId = localStorage.getItem("user_id");
    const userType = localStorage.getItem("user_type")
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { data: productList } = useSelector((state) => state.fetchProductList);
    const [productId, setProductId] = useState("");

    useEffect(() => {
        dispatch(fetchProductList());
    }, [dispatch]);

    useEffect(() => {
        if (productList?.data?.length > 0) {
            const product = productList.data.find(
                (item) => item.metadata.Type.role === userType?.toLowerCase()
            );
            setProductId(product ? product.id : null);
        }
    }, [productList, userType]);

    const handleSubmit = async (e) => {
        if (isSubmitting) return;

        setIsSubmitting(true);
        try {
            const res = await dispatch(
                realtorSubscriptionApi({
                    user_id: userId,
                    product_id: productId,
                    community_id: props.id,
                })
            );
            if (res) {
                props.onHide();
                if (res?.payload?.status === 200) props.fetchSubscription()
                if (res?.payload?.data?.checkout_session)
                    setTimeout(() => {
                        window.location.href = res?.payload?.data?.checkout_session;
                        const currentPage = window.location.pathname;
                        localStorage.setItem("lastVisitedPage", currentPage);
                    }, 500);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsSubmitting(false); // Unlock the button
        }
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="d-flex justify-content-center">
                <Modal.Title className="fw-bold">Subscription Required!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    {/* <h5 className="mb-3">Join the Community</h5> */}
                    <p className="text-muted">
                        Subscribe Now – Get Recognized in the Communities and Cities You Serve.
                    </p>
                    {/* <img
            src="data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='100' height='100' fill='blue'%3E%3Cpath d='M12 2L2 7v4c0 5.55 3.84 10.74 9.21 12 .26.06.53.06.79 0C18.16 21.74 22 16.55 22 11V7l-10-5z'/%3E%3C/svg%3E"
            alt="Subscription Icon"
            className="img-fluid my-3"
          /> */}
                </div>
            </Modal.Body>
            <Modal.Footer className="">
                <button className="bttn-close" onClick={props.onHide}>
                    Close
                </button>
                <button className="bttn-upload" onClick={() => handleSubmit()}>
                    Subscribe Now
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default PurchaseSubscriptionModal